export const scoreValueScale = 2
